/** @jsxImportSource @emotion/react */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons";
import Colors from "styles/colors";

interface ReportsLoadingSpinnerProps {
  message: string;
}

export const ReportsLoadingSpinner: React.FC<ReportsLoadingSpinnerProps> = ({
  message,
}) => {
  return (
    <div
      css={{
        padding: 20,
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FontAwesomeIcon
        icon={faSpinner}
        css={{
          marginRight: 8,
          animation: "spin 1.5s linear infinite",
          color: Colors.biDashboardView.FOCUS_COLOR,
        }}
      />
      <span css={{ color: "#999" }}>{message}</span>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
